export enum SourceEnum {
  User = 'user',
  System = 'system',
}
